import { useMemo } from 'react';

import { NameAndCreateDateFormatter, HeaderRPUImpresisonsFormatter, RPUFormatter, EnabledBadgeFormatter } from '@Components/Grid/components/Table/formatters'
import column, { defaultColumn, defaultActionsColumn, deleteAction, duplicateWithNameAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />, { initialSize: 'max-w-[20vw]' }),
    column.accessor('pathContainerSlots.length', {
      cell: info => info.getValue() || 'N/A',
      header: 'Active Pages',
      enableSorting: false,
    }),
    column.accessor('integrationDataParsed.fraudEnabled', {
      header: 'Fraud',
      cell: info => <EnabledBadgeFormatter info={info} />,
      defaultVisible: false,
      enableSorting: false,
      enableColumnResize: false,
    }),
    column.accessor('meta.overrideDomain', {
      header: 'Domain override',
      cell: info => <EnabledBadgeFormatter info={info} />,
      defaultVisible: false,
      enableSorting: false,
      enableColumnResize: false,
    }),
    column.accessor('impressions', {
      header: () => <HeaderRPUImpresisonsFormatter title='Impressions' />,
      cell: info => info.getValue() || 0,
      enableSorting: false,
    }),
    column.accessor('rpu', {
      header: () => <HeaderRPUImpresisonsFormatter title='RPU' />,
      cell: info => <RPUFormatter info={info} />,
      enableSorting: false,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateWithNameAction),
  ], [])
}
